export default __webpack_public_path__ + "static/rage-610de096d1c92b0ca832b057ee0cd0ab.jpg";